module.exports = __webpack_public_path__ + "static/img/tsid2.8c47175.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tsid2.png
// module id = Ciyh
// module chunks = 1